import axios from "@/axios";
import { TrackerScope, TrackerSort, TrackerTimeState } from "@/enums/index.js";

const endpoint = "/score-usage-tracker";

const BetaScoreTracker = {
  load: async (
    scope = TrackerScope.YOU,
    sort = TrackerSort.RECENT,
    page = 1,
    limit = 20,
    timeState = TrackerTimeState.ACTIVE
  ) => {
    try {
      const response = await axios.get(endpoint, {
        params: { scope, sort, page, limit, timeState },
      });

      const items = response?.items ?? [];
      const total = response?.total ?? 0;
      const currentPage = response?.page ?? page;
      const currentLimit = response?.limit ?? limit;

      const normalized = items.map(item => ({
        businessId: item.businessId,
        name: item.name,
        address: item.address,
        viewedAt: item.viewedAt,
        expiresAt: item.expiresAt,
        daysRemaining: item.daysRemaining,
        tier: item.betaScoreTier,
        riskLevel: item.betaScoreRiskLevel,
        bucket: item.betaScoreColorBucket,
        confidence: item.betaScoreConfidence,
        hasScore: item.hasScore,
      }));

      return {
        ok: true,
        items: normalized,
        pagination: {
          page: currentPage,
          limit: currentLimit,
          total,
          pages: Math.ceil(total / currentLimit),
        },
      };
    } catch (error) {
      console.error("Error loading BetaScore Tracker:", error);

      return {
        ok: false,
        items: [],
        pagination: {
          page,
          limit,
          total: 0,
          pages: 1,
        },
        error: error?.message ?? "Failed to load BetaScore Tracker data",
      };
    }
  },
};

export default BetaScoreTracker;
